import {memo, useMemo} from 'react';

import './styles';
import {COLORS} from '@/styles/colors';

interface LetterAvatarProps {
  icon?: React.ReactNode;
  name?: string;
  size?: number;
  bgColor?: string;
  textColor?: string;
  badgeText?: string;
}

const DEFAULT_BG = COLORS.ON_SURFACE_4;

export const LetterAvatar = memo(
  ({
    icon,
    name,
    size = 32,
    bgColor,
    textColor,
    badgeText,
  }: LetterAvatarProps) => {
    const initial = name?.charAt(0)?.toUpperCase() || '?';
    const badgeTextInitial = badgeText?.charAt(0)?.toUpperCase() || '';

    const style = useMemo(
      () => ({
        width: size,
        height: size,
        backgroundColor: bgColor || DEFAULT_BG,
        color: textColor || undefined,
      }),
      [size, bgColor, textColor],
    );

    return (
      <div
        className="letter-avatar"
        style={style}>
        {icon || initial}
        {badgeTextInitial && (
          <span className="letter-avatar-badge">{badgeTextInitial}</span>
        )}
      </div>
    );
  },
);
